import React from 'react';
import { Clock, Rocket, Users, ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import Button from '@/components/ui/Button';

const benefits = [
  {
    icon: <Clock className="w-full h-full text-orcsys-500" />,
    title: "Développement rapide",
    description: "Nous utilisons des frameworks modernes pour accélérer le développement sans compromettre la qualité."
  },
  {
    icon: <Rocket className="w-full h-full text-orcsys-500" />,
    title: "Prototypage efficace",
    description: "Testez votre concept avec un prototype fonctionnel avant de vous engager dans un développement complet."
  },
  {
    icon: <Users className="w-full h-full text-orcsys-500" />,
    title: "Approche transparente",
    description: "Vous êtes impliqué à chaque étape du processus avec des mises à jour régulières et des démos."
  },
  {
    icon: <ShieldCheck className="w-full h-full text-orcsys-500" />,
    title: "Sécurité intégrée",
    description: "Nous suivons les meilleures pratiques de sécurité pour protéger vos données et celles de vos utilisateurs."
  }
];

const BenefitsSection = () => {
  return (
    <section className="bg-white py-20 lg:py-24">
      <div className="container px-4 mx-auto">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Pourquoi choisir <span className="text-orcsys-500">Orcsys</span> pour votre app mobile?
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Nous nous démarquons par notre expertise, notre approche agile et notre engagement
            à créer des applications qui répondent parfaitement à vos objectifs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg border border-slate-100 hover:border-orcsys-100 transition-all duration-300 hover:shadow-xl h-full"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true, margin: "-100px" }}
            >
              <div className="w-14 h-14 rounded-lg bg-orcsys-50 flex items-center justify-center mb-5 p-3">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{benefit.title}</h3>
              <p className="text-slate-600">{benefit.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div 
          className="mt-10 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Button.Link 
            href="#book"
            className="bg-orcsys-500 hover:bg-orcsys-600 text-white"
          >
            Discuter de votre projet d'application
          </Button.Link>
        </motion.div>
      </div>
    </section>
  );
};

export default BenefitsSection; 